import {
    BarChart,
    Bar,
    LineChart,
    Line,
    XAxis,
    YAxis,
    Legend,
    ResponsiveContainer,
    LabelList,
    Tooltip,
    Cell,
} from "recharts";
import { useState } from "react";



const getUnitLabel = (roleId) => {
    if (roleId === 4 || roleId === 2) return "Cr";
    if (roleId === 5 || roleId === 7) return "Lakhs";
    if (roleId === 1) return "Rs";
    return "";
};


const formatYAxisTick = (value, roleId) => {
    if (roleId === 1) {

        return value.toLocaleString("en-IN");
    }
    if (roleId === 4 || roleId === 2) {

        return (value / 10000000).toFixed(2);
    }
    if (roleId === 5 || roleId === 7) {

        return (value / 100000).toFixed(2);
    }
    return value;
};

const formatBarLabel = (value, roleId) => {
    if (value === null || value === undefined) return "0";

    if (roleId === 1) return value.toLocaleString("en-IN");

    let converted;

    if (roleId === 4 || roleId === 2) {
        converted = value / 10000000;
    } else if (roleId === 5 || roleId === 7) {
        converted = value / 100000;
    } else {
        converted = value;
    }


    const truncated = Math.floor(converted * 100) / 100;

    return truncated.toFixed(2);
};



const CategoryChart = ({ data, roleId, activeTab }) => {

    const [hoveredBar, setHoveredBar] = useState(null);
    return (
        <div style={{
            width: "100%",
            height: 400,
            background: "#ffffff",
            padding: "20px",
            borderRadius: "8px",
            border: "1px solid #000000",
        }}>
            <h3
                style={{
                    textAlign: "center",
                    marginBottom: "15px",
                    fontWeight: "600",
                    color: "#0b6e5a"
                }}
            >
                {activeTab === "Overall"
                    ? `Overall Revenue Status (In ${getUnitLabel(roleId)})`
                    : `${activeTab} Revenue Status (In ${getUnitLabel(roleId)})`}
            </h3>

            <ResponsiveContainer width="100%" height="90%">


                {activeTab === "Overall" ? (
                    <BarChart
                        data={data}
                        barGap={10}
                        barCategoryGap="20%"
                        margin={{ top: 20, right: 30, left: 30, bottom: 10 }}
                    >
                        <XAxis
                            dataKey="name"
                            axisLine={{ stroke: "#000" }}
                            tickLine={{ stroke: "#000" }}
                        />

                        <YAxis
                            width={80}
                            axisLine={{ stroke: "#000" }}
                            tickLine={{ stroke: "#000" }}
                            tickCount={5}
                            domain={[0, 'auto']}
                            tickFormatter={(value) => formatYAxisTick(value, roleId)}
                        />

                        {/*  <Tooltip
                            cursor={{ fill: 'rgba(0, 0, 0, 0.1)' }}
                            formatter={(value, name) => [
                                `${formatBarLabel(value, roleId)} ${getUnitLabel(roleId)}`,
                                name.charAt(0).toUpperCase() + name.slice(1)
                            ]}
                        /> */}

                        <Legend />

                        <Bar dataKey="demand" name='Demand' fill="#692520">
                            <LabelList
                                dataKey="demand"
                                position="top"
                                formatter={(value) => formatBarLabel(value, roleId)}
                            />
                        </Bar>

                        <Bar dataKey="collection" name='Collection' fill="#16a085">
                            <LabelList
                                dataKey="collection"
                                position="top"
                                formatter={(value) => formatBarLabel(value, roleId)}
                            />
                        </Bar>

                        <Bar dataKey="rebate" name='Rebate' fill="#4b6b6f">
                            <LabelList
                                dataKey="rebate"
                                position="top"
                                formatter={(value) => formatBarLabel(value, roleId)}
                            />
                        </Bar>


                        <Bar dataKey="balance" name='Balance' fill="#b8521a">
                            <LabelList
                                dataKey="balance"
                                position="top"
                                formatter={(value) => formatBarLabel(value, roleId)}
                            />
                        </Bar>
                    </BarChart>
                ) : (


                    <LineChart
                        data={data}
                        margin={{ top: 20, right: 30, left: 30, bottom: 10 }}
                    >
                        <XAxis
                            dataKey="name"
                            type="category"
                            scale="point"
                            padding={{ left: 40, right: 40 }}
                        />

                        <YAxis
                            width={80}
                            domain={[0, 'auto']}
                            tickCount={5}
                            tickFormatter={(v) => formatYAxisTick(v, roleId)}
                        />

                        <Tooltip
                            labelFormatter={() => ""}
                            formatter={(value, name, props) => {
                                const label = props.payload.name;

                                const colorMap = {
                                    Demand: "#692520",
                                    Collection: "#16a085",
                                        Rebate: "#4b6b6f",
                                    Balance: "#b8521a"
                                };

                                return [
                                    <span style={{ color: colorMap[label], fontWeight: "600" }}>
                                        {label}: {formatBarLabel(value, roleId)} {getUnitLabel(roleId)}
                                    </span>,
                                    null
                                ];
                            }}
                        />

                        {/*  <Line
                            type="monotone"
                            dataKey="value"
                            // stroke="#999"
                            stroke="#1d86f5"
                            strokeWidth={3}
                            dot={(props) => {
                                const { cx, cy, payload } = props;

                                const colorMap = {
                                    Demand: "#692520",
                                    Collection: "#16a085",
                                    Balance: "#b8521a",
                                };

                                return (
                                    <circle
                                        cx={cx}
                                        cy={cy}
                                        r={6}
                                        fill={colorMap[payload.name]}
                                    />
                                );
                            }}
                            activeDot={(props) => {
                                const { cx, cy, payload } = props;

                                const colorMap = {
                                    Demand: "#692520",
                                    Collection: "#16a085",
                                    Balance: "#b8521a",
                                };

                                return (
                                    <circle
                                        cx={cx}
                                        cy={cy}
                                        r={8}
                                        fill={colorMap[payload.name]}
                                    />
                                );
                            }}
                        /> */}

                        <Line
                            type="monotone"
                            dataKey="value"
                            stroke="#1d86f5"
                            strokeWidth={3}
                            dot={(props) => {
                                const { cx, cy, payload } = props;
                                const colorMap = {
                                    Demand: "#692520",
                                    Collection: "#16a085",
                                        Rebate: "#4b6b6f",
                                    Balance: "#b8521a",
                                };
                                return (
                                    <>
                                        <circle
                                            cx={cx}
                                            cy={cy}
                                            r={6}
                                            fill={colorMap[payload.name]}
                                        />
                                        <text
                                            x={cx}
                                            y={cy - 10}
                                            textAnchor="middle"
                                            fontSize={12}
                                            fontWeight={600}
                                            fill={colorMap[payload.name]}
                                        >
                                            {formatBarLabel(payload.value, roleId)}
                                        </text>
                                    </>
                                );
                            }}
                        />
                    </LineChart>
                )}

            </ResponsiveContainer>
        </div>
    );
};

export default CategoryChart; 